import { Scene, SceneVoiceoverItem } from '@monorepo/types';
import { FunctionComponent, useContext } from 'react';
import { useStore } from '../../../../../../helpers/use-store';
import { Flex, Tag } from 'antd';
import { useVideoContext } from '../../../../../../hooks/use-video';

import './scene-voiceover.scss';

interface Props {
  data: SceneVoiceoverItem;
  scene: Scene;
}

const SceneVoiceover: FunctionComponent<Props> = ({ data, scene }) => {
  const {
    dataStore: { voiceoverStore },
  } = useStore();
  const { video } = useVideoContext();
  const voiceoverId = data.voiceoverId || video?.voiceoverId || '';
  const voiceover = voiceoverStore.get(voiceoverId);
  const voiceoverName = voiceover?.name;

  return (
    <Flex className="scene-voiceover">
      <div>
        <Tag>{voiceoverName || ''}</Tag>
        <div>{scene.text}</div>
      </div>
    </Flex>
  );
};

export default SceneVoiceover;
